import API from './apiUtils/api2';

const cashValueAPI = new API({ url: `/cashvalueletter`});

cashValueAPI.createEntities([
    { name: 'requestCashValueLetter' }
])

const RequestCashValueLetter = (body) => cashValueAPI.endpoints.requestCashValueLetter.post(body);

export {
    RequestCashValueLetter
}